import React, { useRef } from "react"
import { Box, Button, Tooltip, Typography } from "@mui/material"
import Tabs, { tabsClasses } from "@mui/material/Tabs"
import { IconButton, ThemeProvider } from "@mui/material"
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft"

import { CustomTab, HtmlTooltip, LeftIcon, RightIcon, theme } from "./Atom"
import { useDispatch, useSelector } from "react-redux"
import {
  setPnlReportingSelectedClasses,
  setSelectedTransactionClass,
  setTableType,
} from "../../../redux/slices/pnlReportingSlice"
import { tableTypes } from "../../../pages/PnlReporting/constants"
import { useAppSelector } from "../../../redux/hooks"
import { colors } from "../../../../styles/commonStyles"

type pnlTabsProps = {
  lineItem: string | null
}

export default function PnlReportingTabs({ lineItem }: pnlTabsProps) {
  const tabsRef = useRef<any>(null)
  const dispatch = useDispatch()

  const table = useAppSelector((state) => {
    return state.pnlReporting.tableType
  })
  const pnlReportingClasses = useSelector((state: any) => {
    return state.pnlReporting.pnlReportingClasses
  })

  const pnlReportingSelectedClass = useSelector((state: any) => {
    return state.pnlReporting.pnlReportingSelectedClass
  })

  const changeHandler = (tab: any) => {
    dispatch(setPnlReportingSelectedClasses(tab))
  }

  const selectiveEnable = React.useCallback((tab: any, table: any) => {
    return table !== tableTypes.REPORTING
      ? tab?.class_id !== "office_total" && tab?.class_id !== "all_total"
      : true
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          flexGrow: 0,
          maxWidth: { xs: 320, sm: 480, xl: "100%", md: "100%" },
          bgcolor: "#3C77EF",
          display: "flex",
          alignItems: "flex-end",
          color: "primary.main",
          height: "8vh",
          maxHeight: "80px",
          margin: "0px 20px",
        }}
      >
        {lineItem && table !== tableTypes.REPORTING && (
          <Box
            sx={{
              display: "flex",
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              variant="text"
              disableTouchRipple
              startIcon={<KeyboardArrowLeftIcon />}
              sx={{
                color: "#fff",
                textTransform: "none",
                fontWeight: "bold",
                ml: "5px",
                "&:Hover": {
                  textDecoration: "underline",
                  backgroundColor: "transparent",
                },
              }}
              onClick={() => {
                dispatch(setTableType(tableTypes.REPORTING))
                dispatch(setSelectedTransactionClass({}))
              }}
            >
              {lineItem}
            </Button>
          </Box>
        )}
        <Tabs
          ref={tabsRef}
          scrollButtons="auto"
          ScrollButtonComponent={(props) => {
            if (props.direction === "left") {
              return (
                <IconButton
                  size="small"
                  style={{ right: 36 }}
                  {...props}
                  disableRipple={true}
                >
                  <LeftIcon disabled={props.disabled} />
                </IconButton>
              )
            } else if (props.direction === "right") {
              return (
                <IconButton
                  size="small"
                  style={{ right: 0 }}
                  {...props}
                  disableRipple={true}
                >
                  <RightIcon disabled={props.disabled} />
                </IconButton>
              )
            } else {
              return null
            }
          }}
          value={pnlReportingSelectedClass?.class_id || 0}
          variant="scrollable"
          aria-label="select a transaction class"
          sx={{
            color: "primary.main",
            position: "relative",
            paddingRight: 13,
            [`& .${tabsClasses.scrollButtons}`]: {
              position: "absolute",
              "&.Mui-disabled": { opacity: 0.9 },
            },
          }}
          TabIndicatorProps={{
            style: { display: "none" },
          }}
        >
          {pnlReportingClasses?.map((tab: any, index: any) => {
            const enable = selectiveEnable(tab, table)
            const selected =
              pnlReportingSelectedClass?.class_id === tab?.class_id
            return (
              enable && (
                <CustomTab
                  key={tab?.class_id}
                  label={tab?.transaction_class}
                  icon={
                    !tab.transaction_class.toLowerCase().includes("total") ? (
                      <HtmlTooltip
                        title={
                          <Typography color="inherit" fontSize={14}>
                            Book Closed Date: {tab?.book_closed_date || "-"}
                          </Typography>
                        }
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            borderRadius: "50%",
                            width: 12,
                            height: 12,
                            backgroundColor: tab?.is_book_closed
                              ? "#42B2A0"
                              : "#F64E60",
                            // margin: "-10px 0",
                            marginTop: "5px",
                            marginLeft: "5px",
                            // marginBottom: "-5px",
                          }}
                        />
                      </HtmlTooltip>
                    ) : (
                      ""
                    )
                  }
                  iconPosition="end"
                  value={tab?.class_id}
                  onClick={() => {
                    changeHandler(tab)
                  }}
                  style={{
                    backgroundColor: selected ? "#fff" : "#1c56ce",
                    color: selected ? "#000" : "#fff",
                    marginLeft: index === 0 ? "16px" : "none",
                    paddingTop: "10px",
                    fontSize: "16px",
                    alignItems: "center",
                    fontWeight: "600",
                    width: "fit-content",
                    minHeight: "fit-content",
                    textTransform: "capitalize",
                    maxHeight: "70px",
                  }}
                />
              )
            )
          })}
        </Tabs>
      </Box>
    </ThemeProvider>
  )
}
